module.exports = __webpack_public_path__ + "img/register_pc_04.87769383.png";